import router from "@/router";
import store from "@/store/index";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { getToken, removeToken } from "@/utils/auth";
import toast from "@/utils/toast";

NProgress.configure({ showSpinner: false });

async function login(to) {
  // 获取用户信息
  if (!store.getters["user/logged"]) {
    await store.dispatch("user/getInfo");
  }
  // 登录之后，获取用户信息之后
  if (to.matched.some(record => record.meta.requireChat)) {
    if (!window.JIM) {
      await store.dispatch("chat/chatInit");
    }
  }
}

router.beforeEach(async (to, from, next) => {
  NProgress.start();
  if (to.matched.some(record => record.meta.requireAuth)) {
    // 已经登录
    if (getToken()) {
      await login(to);
    } else {
      // 未登录
      next({ name: "login", query: { redirect: window.location.pathname } });
    }
  }
  if (getToken()) {
    await login(to);
  }
  next();
});

router.afterEach(to => {
  if (to.query.redirect) {
    toast("此功能需要登录", 1000);
  }
  NProgress.done();
});
